/**
 * Special properties.
 */
export namespace SpecialProperties {
  export type SpecialParameters =
    | 'GLUTEN_FREE'
    | 'LACTOSE_FREE'
    | 'SUGAR_FREE'
    | 'VEGAN'
    | 'BIO';

  export const SpecialParameters = {
    GlutenFree: 'GLUTEN_FREE' as SpecialParameters,
    LactoseFree: 'LACTOSE_FREE' as SpecialParameters,
    SugarFree: 'SUGAR_FREE' as SpecialParameters,
    Vegan: 'VEGAN' as SpecialParameters,
    Bio: 'BIO' as SpecialParameters,
  };
  export type MarketingLabelsEnum =
    | 'NOVELTY'
    | 'FAVOURITE'
    | 'LIMITED'
    | 'OFFER'
    | 'ONLY_WITH_US'
    | 'AWARD_WINNING';
  export const MarketingLabelsEnum = {
    Novelty: 'NOVELTY' as MarketingLabelsEnum,
    Favourite: 'FAVOURITE' as MarketingLabelsEnum,
    Limited: 'LIMITED' as MarketingLabelsEnum,
    Offer: 'OFFER' as MarketingLabelsEnum,
    OnlyWithUs: 'ONLY_WITH_US' as MarketingLabelsEnum,
    AwardWinning: 'AWARD_WINNING' as MarketingLabelsEnum,
  };
  export type ExperienceCategoriesEnum =
    | 'FAMILY_EVENTS'
    | 'FRIENDLY_CONVERSATIONS'
    | 'SPECIAL_OCCASION'
    | 'ROMANTIC_DINNER'
    | 'PARTY'
    | 'GIFT';
  export const ExperienceCategoriesEnum = {
    FamilyEvents: 'FAMILY_EVENTS' as ExperienceCategoriesEnum,
    FriendlyConversations: 'FRIENDLY_CONVERSATIONS' as ExperienceCategoriesEnum,
    SpecialOccasion: 'SPECIAL_OCCASION' as ExperienceCategoriesEnum,
    RomanticDinner: 'ROMANTIC_DINNER' as ExperienceCategoriesEnum,
    Party: 'PARTY' as ExperienceCategoriesEnum,
    Gift: 'GIFT' as ExperienceCategoriesEnum,
  };
  export type FoodPairingsEnum =
    | 'BEEF'
    | 'PORK'
    | 'POULTRY'
    | 'FISH'
    | 'SEAFOOD'
    | 'VENISON'
    | 'VEGETARIAN'
    | 'SALAD'
    | 'CHEESE'
    | 'DESSERT';
  export const FoodPairingsEnum = {
    Beef: 'BEEF' as FoodPairingsEnum,
    Pork: 'PORK' as FoodPairingsEnum,
    Poultry: 'POULTRY' as FoodPairingsEnum,
    Fish: 'FISH' as FoodPairingsEnum,
    Seafood: 'SEAFOOD' as FoodPairingsEnum,
    Venison: 'VENISON' as FoodPairingsEnum,
    Vegetarian: 'VEGETARIAN' as FoodPairingsEnum,
    Salad: 'SALAD' as FoodPairingsEnum,
    Cheese: 'CHEESE' as FoodPairingsEnum,
    Dessert: 'DESSERT' as FoodPairingsEnum,
  };
}
